import Cookies from "js-cookie";
import {
  PushMarketoLeadInput,
  User,
  usePushMarketoLeadMutation,
} from "@graphql";

type HandleMarketoPushOptions = {
  status: string;
  programId: string;
  leadSourceDetail: string;
  user: Pick<User, "fullName" | "email">;
};

export const useMarketo = () => {
  const [pushMarketoLead] = usePushMarketoLeadMutation();

  return ({
    status,
    programId,
    leadSourceDetail,
    user,
  }: HandleMarketoPushOptions) => {
    // marketing has used both variations of this utm param so we'll need to check for the existance of both
    const UTM_ICID__c =
      Cookies.get("utm_icid") || Cookies.get("utm_ICID") || "-";

    const utmObj: Partial<PushMarketoLeadInput> = {
      UTM_Medium__c: Cookies.get("utm_medium") || "website",
      UTM_Source__c: Cookies.get("utm_source") || "direct",
      UTM_Campaign__c: Cookies.get("utm_campaign") || "-",
      UTM_Term__c: Cookies.get("utm_term") || "-",
      UTM_ICID__c,
      Google_Click_ID__c: Cookies.get("gclid") || "-",
    };

    const [firstName, ...otherNames] = user.fullName.split(" ");
    const lastName = otherNames.join(" ");
    let { email } = user;

    // do to pingone auth, sometimes email is null and the email value is in the name field
    // lets check for that and if it exists, set the email to the name field
    if (!email) {
      const emailRegExp =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (emailRegExp.test(user.fullName)) {
        email = user.fullName;
      }
    }

    pushMarketoLead({
      variables: {
        programId,
        programStatus: status,
        source: "On-demand Training",
        input: {
          email,
          firstName: !lastName ? "" : firstName,
          lastName: !lastName ? firstName : lastName,
          Lead_Source_Most_Recent__c: "On-demand Training",
          Lead_Source_Most_Recent_Detail__c: leadSourceDetail,
          ...utmObj,
        },
      },
    });
  };
};
